module.exports = __webpack_public_path__ + "static/img/landing1.8f8e618.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/landing1.png
// module id = UIpD
// module chunks = 1